module.exports = __webpack_public_path__ + "img/img10.227fb38c.jpg";